import { parseExpression } from '@/helpers/ExpressionParser';

export default new class InsertFormattedText {
    parse(data, values) {
        const parsedExpression = parseExpression(data.data.text, values, 'skip');
        parsedExpression.isPlainText = false;
        return parsedExpression;
    }
};
